<template>
  <div>

    <h2>{{ $t('title.' + action + '.owner') }}</h2>

    <el-row :gutter="40">

      <el-col :span="12">

        <data-form
          model="owners"
          :entity="owner"
          :fields="fields"
          :before-submit="beforeSubmit"
          :after-submit="afterSubmit" />

      </el-col>

      <el-col :span="12">

        <h4>{{ $t('related-organizations') }}</h4>

        <data-table
          model="organizations"
          :columns="['name', 'id']"
          :isSelected="isOrganizationSelected"
          @selection-change="organizationSelectChanged"/>

      </el-col>

    </el-row>

  </div>
</template>

<script>
import ownerFields from './ownerFields'

export default {
  name: 'owner-details',
  data () {
    return {
      relatedOrganizations: [],
      fields: ownerFields
    }
  },
  computed: {
    owner () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['owners/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.owner.new ? 'create' : 'edit'
    }
  },
  methods: {
    beforeSubmit (formModel) {
      formModel.relatedOrganizations = this.relatedOrganizations.map((i) => i.id)
    },
    afterSubmit (formModel) {
      this.$router.back()
    },
    isOrganizationSelected (org) {
      return org.owner_id === this.owner.id
    },
    organizationSelectChanged (selection) {
      this.relatedOrganizations = selection
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// OwnerDetails.vue?d88a7f16